import React, { useState, useEffect, forwardRef } from "react";
import "../components/css/MoleculeStructure.css";
import initRDKit from "./utils/initRDKit";

//mostly taken from rdkit.js docs
const ReactionSVG = forwardRef((props, ref) => {
  const [rdkit, setRdkit] = useState(undefined);

  function drawSVG() {
    if (!rdkit) {
      return;
    }
    const rxn = rdkit.get_rxn(props.rxnSmarts);
    let new_svg = rxn.get_svg();

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "100px !important",
        }}
        dangerouslySetInnerHTML={{ __html: new_svg }}
      ></div>
    );
  }

  useEffect(() => {
    if (rdkit === undefined) {
      initRDKit().then((rd) => {
        setRdkit(rd);
      });
    }
  }, []);

  return drawSVG();
});

export default ReactionSVG;
